export const LIVE_DATA_POLLING_INTERVAL_MS = 5_000;
